import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { PatchUsuarioDto } from '@data/usuario/dto';
import { PatchUsuarioModel, ResponseGetUsuarioAcessoDto } from '@data/usuario/models';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class UsuarioRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.ACCESS_TOKEN);
  }

  getUsuariosAcessos(): Observable<ResponseGetUsuarioAcessoDto> {
    return this.customClient.get(ApiResources.USERS_VINCULADOS);
  }

  patch(body: PatchUsuarioDto): Observable<PatchUsuarioModel> {
    return this.customClient.patch(ApiResources.USERS, body).pipe<any>(
      map((item) => {
        if (item.data) {
          return item.data;
        }
        this.handleResponseRequest(item);
      }),
    );
  }
}
